import { isEqual } from 'lodash';
import React, { useEffect, useState } from 'react';
import {
  ICompanyFormation,
  ICompanyFormationFullObject,
} from '../../Interfaces/ICompanyFormation';
import { ICompanyFormationAnswer } from '../../Interfaces/ICompanyFormationAnswer';
import { ICompanyFormationHasShareHolder } from '../../Interfaces/ICompanyFormationHasShareHolder';
import { ICompanyFormationShare } from '../../Interfaces/ICompanyFormationShare';
import { IShareHolderFullObject } from '../../Interfaces/IShareHolder';
import { ShareHolderRepresentationWarning } from './Childs/ShareHolder/ShareHolderRepresentationWarning';
import { Summary } from './Childs/Summary';
import { RASummary } from '../RegisteredAssociation/Childs/RASummary';

interface IProps {
  companyFormationObject: ICompanyFormationFullObject;
  setCompanyFormationObject: Function;
}

export const CompanyFormationMain: React.FC<IProps> = ({
  companyFormationObject,
  setCompanyFormationObject,
}) => {
  const [companyFormationEdit, setCompanyFormationEdit] =
    useState<ICompanyFormation>(companyFormationObject);
  const [shareHolderArray, setShareHolderArray] = useState<
    IShareHolderFullObject[]
  >(companyFormationObject.ShareHolderArray);
  const [companyFormationShareArray, setCompanyFormationShareArray] = useState<
    ICompanyFormationShare[]
  >(companyFormationObject.CompanyFormationShareArray);
  const [shareHolderRelation, setShareHolderRelation] = useState<
    ICompanyFormationHasShareHolder[]
  >(companyFormationObject.CompanyFormationHasShareHolderArray);
  const [companyFormationAnswerArray, setCompanyFormationAnswerArray] =
    useState<ICompanyFormationAnswer[]>(
      companyFormationObject.CompanyFormationAnswerArray
    );

  useEffect(() => {
    if (!isEqual(companyFormationEdit, companyFormationObject)) {
      setCompanyFormationEdit(companyFormationObject);
      setShareHolderArray(companyFormationObject.ShareHolderArray);
      setCompanyFormationShareArray(
        companyFormationObject.CompanyFormationShareArray
      );
      setShareHolderRelation(
        companyFormationObject.CompanyFormationHasShareHolderArray
      );
      setCompanyFormationAnswerArray(
        companyFormationObject.CompanyFormationAnswerArray
      );
    }
  }, [companyFormationObject]);

  useEffect(() => {
    setCompanyFormationObject({
      ...companyFormationEdit,
      ShareHolderArray: shareHolderArray,
      CompanyFormationHasShareHolderArray: shareHolderRelation,
      CompanyFormationShareArray: companyFormationShareArray,
      CompanyFormationAnswerArray: companyFormationAnswerArray,
    } as ICompanyFormationFullObject);
  }, [
    companyFormationEdit,
    shareHolderArray,
    companyFormationShareArray,
    shareHolderRelation,
    companyFormationAnswerArray,
  ]);

  return (
    <>
      {/*<Box sx={{ float: 'right' }}>
        <ExportCompanyFormation
          idCompanyFormation={companyFormationObject.idCompanyFormation}
        />
      </Box>*/}

      {companyFormationObject.idBusinessForm === 12 ? (
        <RASummary
          companyFormationObject={companyFormationObject}
          setCompanyFormationObject={setCompanyFormationObject}
        />
      ) : (
        <>
          <ShareHolderRepresentationWarning
            shareHolderArray={shareHolderArray}
            shareHolderRelationArray={shareHolderRelation}
          />

          <Summary
            companyFormationObject={companyFormationEdit}
            setCompanyFormationObject={setCompanyFormationEdit}
            companyFormationShareArray={companyFormationShareArray}
            setCompanyFormationShareArray={setCompanyFormationShareArray}
            shareHolderArray={shareHolderArray}
            setShareHolderArray={setShareHolderArray}
            shareHolderRelation={shareHolderRelation}
            setShareHolderRelation={setShareHolderRelation}
            companyFormationAnswerArray={companyFormationAnswerArray}
            setCompanyFormationAnswerArray={setCompanyFormationAnswerArray}
          />
        </>
      )}
    </>
  );
};
